const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Bundles = require("../Bundles");
const ModalClose = require("./ModalClose");
const {Portal} = require("./Portal");
const ReactModal2 = require("react-modal2").default;

const styles = require("./styles/ModalGeneral.css");

module.exports = createReactClass({
	displayName: "ModalView",

	propTypes: {
		onClose: PT.func,
		closeOnEsc: PT.bool,
		closeOnBackdropClick: PT.bool,
		hasCloseButton: PT.bool,
		portalContainer: PT.string,
		levelType: PT.oneOf(["default", "aboveAll"]),
		backdropClass: PT.string,
		modalClass: PT.string,
		closeClass: PT.string,
		backdropStyles: PT.object,
		modalStyles: PT.object,
	},

	handleClose: function() {
		this.props.onClose();
	},

	componentDidMount: function() {
		const Banvas = Bundles.requireOpt("trainer", "Banvas");
		if (Banvas) {
			this.banvasLock = Banvas.addFocusLock();
		}
	},

	componentWillUnmount: function() {
		const Banvas = Bundles.requireOpt("trainer", "Banvas");
		if (Banvas && this.banvasLock) {
			Banvas.removeFocusLock(this.banvasLock);
		}
	},

	render: function() {
		let {backdropClass, modalClass} = this.props;
		const {
			hasCloseButton,
			closeOnEsc,
			closeOnBackdropClick,
			backdropStyles,
			modalStyles,
			children,
			portalContainer,
			levelType,
			closeClass,
		} = this.props;

		if (levelType) {
			modalClass += " " + styles[levelType + "ModalZ"];
			backdropClass += " " + styles[levelType + "ModalBackdropZ"];
		}
		const closeButton = hasCloseButton ? (
			<ModalClose onClick={this.handleClose} extraClassName={closeClass} />
		) : null;
		const modal = (
			<ReactModal2
				onClose={this.handleClose}
				closeOnEsc={closeOnEsc !== false}
				closeOnBackdropClick={closeOnBackdropClick !== false}
				backdropClassName={backdropClass}
				modalClassName={modalClass}
				backdropStyles={backdropStyles}
				modalStyles={modalStyles}
			>
				{children}
				{closeButton}
			</ReactModal2>
		);

		if (portalContainer) {
			return <Portal container={portalContainer}>{modal}</Portal>;
		} else {
			return modal;
		}
	},
});
